/*!
 * @piconetworks/box v3.5.2
 * (c) 
 */
'use strict';

var React = require('react');
var cx = require('classnames');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var styles$3 = {"left":"RegularBox-module_left__1Mk6J","center":"RegularBox-module_center__3mC9N","right":"RegularBox-module_right__nVT7o"};

var _excluded$b = ["children", "className", "alignText"];

var RegularBox = function RegularBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignText = _ref.alignText,
      props = _objectWithoutProperties(_ref, _excluded$b);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    className: cx__default["default"](styles$3[alignText], className)
  }, props), children);
};

RegularBox.propTypes = {
  /** Aligns children using text-align */
  alignText: PropTypes__default["default"].oneOf(['left', 'center', 'right']),
  children: PropTypes__default["default"].node,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object])
};
RegularBox.defaultProps = {
  alignText: 'left'
};

var style$3 = {"displayInlineFlex":"FlexboxContainer-module_displayInlineFlex__QxBsQ","displayFlex":"FlexboxContainer-module_displayFlex__2SHF4"};

var _excluded$a = ["alignItems", "children", "className", "flexDirection", "flexWrap", "inline", "justifyContent"];
var FlexboxContainer = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var alignItems = _ref.alignItems,
      children = _ref.children,
      className = _ref.className,
      flexDirection = _ref.flexDirection,
      flexWrap = _ref.flexWrap,
      inline = _ref.inline,
      justifyContent = _ref.justifyContent,
      props = _objectWithoutProperties(_ref, _excluded$a);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    className: cx__default["default"](inline ? style$3.displayInlineFlex : style$3.displayFlex, alignItems && "align-items-".concat(alignItems), flexDirection && "flex-".concat(flexDirection), flexWrap && "flex-".concat(flexWrap), justifyContent && "justify-content-".concat(justifyContent), className),
    ref: ref
  }, props), children);
});
FlexboxContainer.propTypes = {
  /** This defines the alignment along the cross axis. */
  alignItems: PropTypes__default["default"].oneOf(['stretch', 'center', 'start', 'end', 'baseline', 'initial']),
  children: PropTypes__default["default"].node,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),

  /** Whether the container is display inline-flex (true) or just flex (false) */
  inline: PropTypes__default["default"].bool,

  /** Defines direction flex items are placed in the flex container */
  flexDirection: PropTypes__default["default"].oneOf(['row', 'column', 'row-reverse', 'column-reverse']),

  /** Whether to wrap to the next line */
  flexWrap: PropTypes__default["default"].oneOf(['wrap', 'nowrap', 'wrap-reverse']),

  /** This defines the alignment along the main axis. */
  justifyContent: PropTypes__default["default"].oneOf(['start', 'end', 'center', 'between', 'around', 'initial'])
};
FlexboxContainer.defaultProps = {
  inline: false,
  flexDirection: 'row',
  flexWrap: 'nowrap'
};

var _excluded$9 = ["alignSelf", "children", "className", "flex", "flexFill", "flexGrow", "flexShrink"];

var FlexboxChild = function FlexboxChild(_ref) {
  var alignSelf = _ref.alignSelf,
      children = _ref.children,
      className = _ref.className,
      flex = _ref.flex,
      flexFill = _ref.flexFill,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      props = _objectWithoutProperties(_ref, _excluded$9);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    className: cx__default["default"](flexFill && 'flex-fill', flexGrow && "flex-grow-".concat(flexGrow), flexShrink && "flex-shrink-".concat(flexShrink), alignSelf && "align-self-".concat(alignSelf), className),
    style: {
      flex: flex
    }
  }, props), children);
};

FlexboxChild.propTypes = {
  alignSelf: PropTypes__default["default"].oneOf(['start', 'end', 'center', 'between', 'around', 'initial']),
  children: PropTypes__default["default"].node,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),

  /**
   * This is the shorthand for flex-grow, flex-shrink and flex-basis combined.
   */
  flex: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number]),

  /**
   * Set this on a series of sibling elements to force them into widths equal
   * to their content (or equal widths if their content does not surpass their border-boxes)
   * while taking up all available horizontal space.
   * */
  flexFill: PropTypes__default["default"].bool,

  /**
   * This defines the ability for a flex item to grow if necessary.
   * It accepts a unitless value that serves as a proportion.
   * It dictates what amount of the available space inside the flex container the item should take up.
   */
  flexGrow: PropTypes__default["default"].number,

  /**
   * This defines the ability for a flex item to shrink if necessary.
   */
  flexShrink: PropTypes__default["default"].number
}; // maybe i can remove this?

var Flexbox = {
  Child: FlexboxChild,
  Container: FlexboxContainer
};

var styles$2 = {"flexboxPaneContainer":"FlexboxPane-module_flexboxPaneContainer__IRPNl","flexboxPaneChild":"FlexboxPane-module_flexboxPaneChild__8kBW1"};

var _excluded$8 = ["children", "className", "flexboxContainer"];

var FlexboxPaneContainer = function FlexboxPaneContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flexboxContainer = _ref.flexboxContainer,
      props = _objectWithoutProperties(_ref, _excluded$8);

  return /*#__PURE__*/React__default["default"].createElement(Flexbox.Container, _extends({
    className: cx__default["default"](styles$2.flexboxPaneContainer, className)
  }, flexboxContainer, props), children);
};

FlexboxPaneContainer.propTypes = {
  children: PropTypes__default["default"].node,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),
  flexboxContainer: PropTypes__default["default"].object
};
FlexboxPaneContainer.defaultProps = {
  flexboxContainer: {
    alignItems: 'start',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
};

var _excluded$7 = ["children", "className", "flexboxChild", "noTopPadding", "noRightPadding", "noBottomPadding", "noLeftPadding"];

var FlexboxPaneChild = function FlexboxPaneChild(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flexboxChild = _ref.flexboxChild,
      noTopPadding = _ref.noTopPadding,
      noRightPadding = _ref.noRightPadding,
      noBottomPadding = _ref.noBottomPadding,
      noLeftPadding = _ref.noLeftPadding,
      props = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React__default["default"].createElement(Flexbox.Child, _extends({
    className: cx__default["default"](styles$2.flexboxPaneChild, noTopPadding && 'pt-0', noRightPadding && 'pr-0', noBottomPadding && 'pb-0', noLeftPadding && 'pl-0', className)
  }, flexboxChild, props), children);
};

FlexboxPaneChild.propTypes = {
  children: PropTypes__default["default"].node,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),
  flexboxChild: PropTypes__default["default"].object,
  noTopPadding: PropTypes__default["default"].bool,
  noRightPadding: PropTypes__default["default"].bool,
  noBottomPadding: PropTypes__default["default"].bool,
  noLeftPadding: PropTypes__default["default"].bool
};
FlexboxPaneChild.defaultProps = {
  flexboxChild: {
    flexFill: true
  },
  noTopPadding: false,
  noRightPadding: false,
  noBottomPadding: false,
  noLeftPadding: false
};

var FlexboxPane = {
  Child: FlexboxPaneChild,
  Container: FlexboxPaneContainer
};

var styles$1 = {"scrollableWrapper":"Scrollable-module_scrollableWrapper__RHfdm","scrollableHeader":"Scrollable-module_scrollableHeader__33e76","scrollableContainer":"Scrollable-module_scrollableContainer__3FK1F"};

var _excluded$6 = ["children", "styleClass", "className"];

var ScrollableTemplate = function ScrollableTemplate(_ref) {
  var children = _ref.children,
      styleClass = _ref.styleClass,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded$6);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    className: cx__default["default"](className, styles$1[styleClass])
  }, props), children);
};

ScrollableTemplate.propTypes = {
  children: PropTypes__default["default"].node,
  styleClass: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object])
};

var _excluded$5 = ["children"];

var createTemplate = function createTemplate(styleClass) {
  return function (_ref) {
    var children = _ref.children,
        props = _objectWithoutProperties(_ref, _excluded$5);

    return /*#__PURE__*/React__default["default"].createElement(ScrollableTemplate, _extends({
      styleClass: styleClass
    }, props), children);
  };
};

var Scrollable = {
  Wrapper: createTemplate('scrollableWrapper'),
  Header: createTemplate('scrollableHeader'),
  Container: createTemplate('scrollableContainer')
};

var style$2 = {"container":"GridContainer-module_container__uUS-U","container-fluid":"GridContainer-module_container-fluid__P-XyP","container-sm":"GridContainer-module_container-sm__148lT","container-md":"GridContainer-module_container-md__3j-TF","container-lg":"GridContainer-module_container-lg__2OWz7","container-xl":"GridContainer-module_container-xl__2nufj"};

var _excluded$4 = ["fluid", "className"];
var GridContainer = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var fluid = _ref.fluid,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    className: cx__default["default"](fluid ? style$2["container".concat(suffix)] : style$2['container'], className),
    ref: ref
  }, props));
});
var GridContainerPropTypes = {
  fluid: PropTypes__default["default"].oneOf([true, false, 'sm', 'md', 'lg', 'xl', 'xxl']),
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object])
};
GridContainer.propTypes = GridContainerPropTypes;
GridContainer.defaultProps = {
  fluid: false
};
GridContainer.displayName = 'GridContainer';

var style$1 = {"row":"GridRow-module_row__10kAE","displayInlineFlex":"GridRow-module_displayInlineFlex__Teu94","no-gutters":"GridRow-module_no-gutters__1I-Fw","col":"GridRow-module_col__1we2C"};

var _excluded$3 = ["noGutters", "className"];
var GridRow = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var noGutters = _ref.noGutters,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded$3);

  var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
  var sizePrefix = 'row-cols';
  var classes = [];
  DEVICE_SIZES.forEach(function (breakpoint) {
    var propValue = props[breakpoint];
    delete props[breakpoint];
    var cols;

    if (propValue != null && _typeof(propValue) === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }

    var infix = breakpoint !== 'xs' ? "-".concat(breakpoint) : '';
    if (cols != null) classes.push(style$1["".concat(sizePrefix).concat(infix, "-").concat(cols)]);
  });
  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    ref: ref
  }, props, {
    className: cx__default["default"].apply(void 0, [noGutters && style$1['no-gutters'], style$1.row, className].concat(classes))
  }));
});
var rowColWidth = PropTypes__default["default"].oneOfType([PropTypes__default["default"].number, PropTypes__default["default"].string]);
var rowColumns = PropTypes__default["default"].oneOfType([rowColWidth, PropTypes__default["default"].shape({
  cols: rowColWidth
})]);
var GridRowPropTypes = {
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),

  /** Removes the gutter spacing between Cols as well as any added negative margins. */
  noGutters: PropTypes__default["default"].bool,
  xs: rowColumns,
  sm: rowColumns,
  md: rowColumns,
  lg: rowColumns,
  xl: rowColumns
};
GridRow.propTypes = GridRowPropTypes;
GridRow.defaultProps = {
  noGutters: false
};
GridRow.displayName = 'GridRow';

var style = {"col-1":"GridCol-module_col-1__KhqhE","col-2":"GridCol-module_col-2__2OwtE","col-3":"GridCol-module_col-3__1SYSc","col-4":"GridCol-module_col-4___i2d-","col-5":"GridCol-module_col-5__3pGTy","col-6":"GridCol-module_col-6__2Q5c_","col-7":"GridCol-module_col-7__1gwQe","col-8":"GridCol-module_col-8__1iENa","col-9":"GridCol-module_col-9__1X-g2","col-10":"GridCol-module_col-10__1v5mM","col-11":"GridCol-module_col-11__3n62g","col-12":"GridCol-module_col-12__2lVUk","col":"GridCol-module_col__1JjZP","col-auto":"GridCol-module_col-auto__14iKE","col-sm-1":"GridCol-module_col-sm-1__1QKIN","col-sm-2":"GridCol-module_col-sm-2__2T6by","col-sm-3":"GridCol-module_col-sm-3__251Iq","col-sm-4":"GridCol-module_col-sm-4__1vkh7","col-sm-5":"GridCol-module_col-sm-5__3nlfA","col-sm-6":"GridCol-module_col-sm-6__2--I7","col-sm-7":"GridCol-module_col-sm-7__3wAfI","col-sm-8":"GridCol-module_col-sm-8__3cyDm","col-sm-9":"GridCol-module_col-sm-9__24r-a","col-sm-10":"GridCol-module_col-sm-10__3XqsE","col-sm-11":"GridCol-module_col-sm-11__U2lTw","col-sm-12":"GridCol-module_col-sm-12__2r-Zc","col-sm":"GridCol-module_col-sm__3wtk1","col-sm-auto":"GridCol-module_col-sm-auto__3pJyv","col-md-1":"GridCol-module_col-md-1__20vCP","col-md-2":"GridCol-module_col-md-2__3b-yp","col-md-3":"GridCol-module_col-md-3__3PwwD","col-md-4":"GridCol-module_col-md-4__UT95P","col-md-5":"GridCol-module_col-md-5__8lT45","col-md-6":"GridCol-module_col-md-6__2xg9D","col-md-7":"GridCol-module_col-md-7__k2FZA","col-md-8":"GridCol-module_col-md-8__32ejM","col-md-9":"GridCol-module_col-md-9__1otpP","col-md-10":"GridCol-module_col-md-10__9aXKe","col-md-11":"GridCol-module_col-md-11__3gxFs","col-md-12":"GridCol-module_col-md-12__2-sgs","col-md":"GridCol-module_col-md__QG5lg","col-md-auto":"GridCol-module_col-md-auto__3x5su","col-lg-1":"GridCol-module_col-lg-1__1zmDK","col-lg-2":"GridCol-module_col-lg-2__kDSLo","col-lg-3":"GridCol-module_col-lg-3__16Vxw","col-lg-4":"GridCol-module_col-lg-4__3vFlr","col-lg-5":"GridCol-module_col-lg-5__KFzKQ","col-lg-6":"GridCol-module_col-lg-6__ITor7","col-lg-7":"GridCol-module_col-lg-7__1U7KP","col-lg-8":"GridCol-module_col-lg-8__2YH8H","col-lg-9":"GridCol-module_col-lg-9__27pfY","col-lg-10":"GridCol-module_col-lg-10__3D7Jm","col-lg-11":"GridCol-module_col-lg-11__1a7tn","col-lg-12":"GridCol-module_col-lg-12__1x4BM","col-lg":"GridCol-module_col-lg__1VIrS","col-lg-auto":"GridCol-module_col-lg-auto__3jChX","col-xl-1":"GridCol-module_col-xl-1__3RHms","col-xl-2":"GridCol-module_col-xl-2__314Va","col-xl-3":"GridCol-module_col-xl-3__4Zwi8","col-xl-4":"GridCol-module_col-xl-4__3yCng","col-xl-5":"GridCol-module_col-xl-5__2gtA-","col-xl-6":"GridCol-module_col-xl-6__3CoVL","col-xl-7":"GridCol-module_col-xl-7__1XoG1","col-xl-8":"GridCol-module_col-xl-8__1Da9U","col-xl-9":"GridCol-module_col-xl-9__2xhyU","col-xl-10":"GridCol-module_col-xl-10__12dNf","col-xl-11":"GridCol-module_col-xl-11__8f1u_","col-xl-12":"GridCol-module_col-xl-12__3C0M-","col-xl":"GridCol-module_col-xl__2qpWQ","col-xl-auto":"GridCol-module_col-xl-auto__1VbyZ","row-cols-1":"GridCol-module_row-cols-1__36EvI","row-cols-2":"GridCol-module_row-cols-2__3ikLy","row-cols-3":"GridCol-module_row-cols-3__vwsad","row-cols-4":"GridCol-module_row-cols-4__3xLJK","row-cols-5":"GridCol-module_row-cols-5__1fa07","row-cols-6":"GridCol-module_row-cols-6__z8f0d","order-first":"GridCol-module_order-first__13NBT","order-last":"GridCol-module_order-last__1o4t9","order-0":"GridCol-module_order-0__IUfp1","order-1":"GridCol-module_order-1__AU-Uv","order-2":"GridCol-module_order-2__1fFDk","order-3":"GridCol-module_order-3__qF-vY","order-4":"GridCol-module_order-4__2OXd_","order-5":"GridCol-module_order-5__1OTGm","order-6":"GridCol-module_order-6__1vdW1","order-7":"GridCol-module_order-7__2Fk8X","order-8":"GridCol-module_order-8__uswHL","order-9":"GridCol-module_order-9__1yCtV","order-10":"GridCol-module_order-10__3W1hp","order-11":"GridCol-module_order-11__2U0rh","order-12":"GridCol-module_order-12__27r01","offset-1":"GridCol-module_offset-1__39Sts","offset-2":"GridCol-module_offset-2__2z_-Z","offset-3":"GridCol-module_offset-3__k3DwL","offset-4":"GridCol-module_offset-4__GNeUW","offset-5":"GridCol-module_offset-5__38SRb","offset-6":"GridCol-module_offset-6__2qs2w","offset-7":"GridCol-module_offset-7__2RkCm","offset-8":"GridCol-module_offset-8__39nKt","offset-9":"GridCol-module_offset-9__1LRoj","offset-10":"GridCol-module_offset-10__gq091","offset-11":"GridCol-module_offset-11__2jz1u","row-cols-sm-1":"GridCol-module_row-cols-sm-1__2Qv3D","row-cols-sm-2":"GridCol-module_row-cols-sm-2__MhKre","row-cols-sm-3":"GridCol-module_row-cols-sm-3__14QXI","row-cols-sm-4":"GridCol-module_row-cols-sm-4__3N4i3","row-cols-sm-5":"GridCol-module_row-cols-sm-5__1k7VL","row-cols-sm-6":"GridCol-module_row-cols-sm-6__1S3hn","order-sm-first":"GridCol-module_order-sm-first__1oCNA","order-sm-last":"GridCol-module_order-sm-last__28Fda","order-sm-0":"GridCol-module_order-sm-0__1PMh1","order-sm-1":"GridCol-module_order-sm-1__2ynMl","order-sm-2":"GridCol-module_order-sm-2__2L7bj","order-sm-3":"GridCol-module_order-sm-3__2jlUI","order-sm-4":"GridCol-module_order-sm-4__2PNkf","order-sm-5":"GridCol-module_order-sm-5__2fgoX","order-sm-6":"GridCol-module_order-sm-6__2TCsR","order-sm-7":"GridCol-module_order-sm-7__WcI4B","order-sm-8":"GridCol-module_order-sm-8__1TXYH","order-sm-9":"GridCol-module_order-sm-9__3q9hf","order-sm-10":"GridCol-module_order-sm-10__3BdnQ","order-sm-11":"GridCol-module_order-sm-11__RgOZ7","order-sm-12":"GridCol-module_order-sm-12__lGhco","offset-sm-0":"GridCol-module_offset-sm-0__9BpBU","offset-sm-1":"GridCol-module_offset-sm-1__3krxk","offset-sm-2":"GridCol-module_offset-sm-2__beAHb","offset-sm-3":"GridCol-module_offset-sm-3__24NwJ","offset-sm-4":"GridCol-module_offset-sm-4__2GFDP","offset-sm-5":"GridCol-module_offset-sm-5__2V3VU","offset-sm-6":"GridCol-module_offset-sm-6__GpZBy","offset-sm-7":"GridCol-module_offset-sm-7__POb8C","offset-sm-8":"GridCol-module_offset-sm-8__2OJni","offset-sm-9":"GridCol-module_offset-sm-9__1IiO5","offset-sm-10":"GridCol-module_offset-sm-10__2TKYN","offset-sm-11":"GridCol-module_offset-sm-11__2NnwZ","row-cols-md-1":"GridCol-module_row-cols-md-1__22VkC","row-cols-md-2":"GridCol-module_row-cols-md-2__2PiRO","row-cols-md-3":"GridCol-module_row-cols-md-3__1GnGb","row-cols-md-4":"GridCol-module_row-cols-md-4__zAUEp","row-cols-md-5":"GridCol-module_row-cols-md-5__1DB9t","row-cols-md-6":"GridCol-module_row-cols-md-6__2AZEV","order-md-first":"GridCol-module_order-md-first__2d1aO","order-md-last":"GridCol-module_order-md-last__dEPxG","order-md-0":"GridCol-module_order-md-0__2KPnJ","order-md-1":"GridCol-module_order-md-1__34jCn","order-md-2":"GridCol-module_order-md-2__28cXJ","order-md-3":"GridCol-module_order-md-3__3O5ID","order-md-4":"GridCol-module_order-md-4__3xh9Z","order-md-5":"GridCol-module_order-md-5__1p6Bu","order-md-6":"GridCol-module_order-md-6__jiava","order-md-7":"GridCol-module_order-md-7__1uQRn","order-md-8":"GridCol-module_order-md-8__2qeY_","order-md-9":"GridCol-module_order-md-9__MP5Ah","order-md-10":"GridCol-module_order-md-10__3aLh_","order-md-11":"GridCol-module_order-md-11__17zrV","order-md-12":"GridCol-module_order-md-12__2z9XF","offset-md-0":"GridCol-module_offset-md-0__aERXs","offset-md-1":"GridCol-module_offset-md-1__4-wli","offset-md-2":"GridCol-module_offset-md-2__3U-U2","offset-md-3":"GridCol-module_offset-md-3__3aSF9","offset-md-4":"GridCol-module_offset-md-4__1JTwV","offset-md-5":"GridCol-module_offset-md-5__1dUU3","offset-md-6":"GridCol-module_offset-md-6__3V_a6","offset-md-7":"GridCol-module_offset-md-7__3bjIF","offset-md-8":"GridCol-module_offset-md-8__1cWCJ","offset-md-9":"GridCol-module_offset-md-9__3gYlx","offset-md-10":"GridCol-module_offset-md-10__2Wace","offset-md-11":"GridCol-module_offset-md-11__XlI-O","row-cols-lg-1":"GridCol-module_row-cols-lg-1__1pRqT","row-cols-lg-2":"GridCol-module_row-cols-lg-2__1SFx8","row-cols-lg-3":"GridCol-module_row-cols-lg-3__2J1IK","row-cols-lg-4":"GridCol-module_row-cols-lg-4__2KFuK","row-cols-lg-5":"GridCol-module_row-cols-lg-5__1EtCv","row-cols-lg-6":"GridCol-module_row-cols-lg-6__Vg6tN","order-lg-first":"GridCol-module_order-lg-first__2Jt1K","order-lg-last":"GridCol-module_order-lg-last__2lhAA","order-lg-0":"GridCol-module_order-lg-0__JudSL","order-lg-1":"GridCol-module_order-lg-1__1ObMQ","order-lg-2":"GridCol-module_order-lg-2__1nwyz","order-lg-3":"GridCol-module_order-lg-3__2AWLp","order-lg-4":"GridCol-module_order-lg-4__25ovi","order-lg-5":"GridCol-module_order-lg-5__dflR_","order-lg-6":"GridCol-module_order-lg-6__2WgaY","order-lg-7":"GridCol-module_order-lg-7__3Br73","order-lg-8":"GridCol-module_order-lg-8__13D8J","order-lg-9":"GridCol-module_order-lg-9__3hJxf","order-lg-10":"GridCol-module_order-lg-10__1ymjo","order-lg-11":"GridCol-module_order-lg-11__3w2V-","order-lg-12":"GridCol-module_order-lg-12__VCBSf","offset-lg-0":"GridCol-module_offset-lg-0__2ZfmS","offset-lg-1":"GridCol-module_offset-lg-1__3nSEo","offset-lg-2":"GridCol-module_offset-lg-2__uQvpB","offset-lg-3":"GridCol-module_offset-lg-3__2mPj8","offset-lg-4":"GridCol-module_offset-lg-4__2Oqwx","offset-lg-5":"GridCol-module_offset-lg-5__bUEcl","offset-lg-6":"GridCol-module_offset-lg-6__23hjl","offset-lg-7":"GridCol-module_offset-lg-7__t-nEJ","offset-lg-8":"GridCol-module_offset-lg-8__1AwIt","offset-lg-9":"GridCol-module_offset-lg-9__bUJ5_","offset-lg-10":"GridCol-module_offset-lg-10__skDqD","offset-lg-11":"GridCol-module_offset-lg-11__1EwH1","row-cols-xl-1":"GridCol-module_row-cols-xl-1__2RD-O","row-cols-xl-2":"GridCol-module_row-cols-xl-2__32Rq5","row-cols-xl-3":"GridCol-module_row-cols-xl-3__1prlg","row-cols-xl-4":"GridCol-module_row-cols-xl-4__2Za2T","row-cols-xl-5":"GridCol-module_row-cols-xl-5__2DyXI","row-cols-xl-6":"GridCol-module_row-cols-xl-6__2yVN7","order-xl-first":"GridCol-module_order-xl-first__IUxXY","order-xl-last":"GridCol-module_order-xl-last__3RC81","order-xl-0":"GridCol-module_order-xl-0__1tCpy","order-xl-1":"GridCol-module_order-xl-1__1rweD","order-xl-2":"GridCol-module_order-xl-2__1qFsA","order-xl-3":"GridCol-module_order-xl-3__1AEHG","order-xl-4":"GridCol-module_order-xl-4__3scLp","order-xl-5":"GridCol-module_order-xl-5__7Gz2z","order-xl-6":"GridCol-module_order-xl-6__1okGH","order-xl-7":"GridCol-module_order-xl-7__294jz","order-xl-8":"GridCol-module_order-xl-8__2hUdp","order-xl-9":"GridCol-module_order-xl-9__3jQGv","order-xl-10":"GridCol-module_order-xl-10__2gY3t","order-xl-11":"GridCol-module_order-xl-11__16Wei","order-xl-12":"GridCol-module_order-xl-12__3uygr","offset-xl-0":"GridCol-module_offset-xl-0__1XBWO","offset-xl-1":"GridCol-module_offset-xl-1__2EdLD","offset-xl-2":"GridCol-module_offset-xl-2__3cnQV","offset-xl-3":"GridCol-module_offset-xl-3__13DW5","offset-xl-4":"GridCol-module_offset-xl-4__1MoAI","offset-xl-5":"GridCol-module_offset-xl-5__1O6A6","offset-xl-6":"GridCol-module_offset-xl-6__5Xcl5","offset-xl-7":"GridCol-module_offset-xl-7__YqBWA","offset-xl-8":"GridCol-module_offset-xl-8__1foFH","offset-xl-9":"GridCol-module_offset-xl-9__3hQBj","offset-xl-10":"GridCol-module_offset-xl-10__TDVBO","offset-xl-11":"GridCol-module_offset-xl-11__3sNsZ"};

var _excluded$2 = ["className"];
var GridCol = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
  var prefix = 'col';
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (breakpoint) {
    var propValue = props[breakpoint];
    delete props[breakpoint];
    var span;
    var offset;
    var order;

    if (_typeof(propValue) === 'object' && propValue != null) {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = breakpoint !== 'xs' ? "-".concat(breakpoint) : '';

    if (span) {
      spans.push(span === true ? style["".concat(prefix).concat(infix)] : style["".concat(prefix).concat(infix, "-").concat(span)]);
    }

    if (order != null) classes.push(style["order".concat(infix, "-").concat(order)]);
    if (offset != null) classes.push(style["offset".concat(infix, "-").concat(offset)]);
  });

  if (!spans.length) {
    spans.push(style[prefix]); // just plain 'col'
  }

  return /*#__PURE__*/React__default["default"].createElement("div", _extends({}, props, {
    ref: ref,
    className: cx__default["default"].apply(void 0, [className].concat(spans, classes))
  }));
});
var colSize = PropTypes__default["default"].oneOfType([PropTypes__default["default"].bool, PropTypes__default["default"].number, PropTypes__default["default"].string, PropTypes__default["default"].oneOf(['auto'])]);
var stringOrNumber = PropTypes__default["default"].oneOfType([PropTypes__default["default"].number, PropTypes__default["default"].string]);
var column = PropTypes__default["default"].oneOfType([colSize, PropTypes__default["default"].shape({
  size: colSize,
  order: stringOrNumber,
  offset: stringOrNumber
})]);
var GridColPropTypes = {
  /**
  * The number of columns to span on extra small devices
  */
  xs: column,

  /**
  * The number of columns to span on small devices
  */
  sm: column,

  /**
  * The number of columns to span on medium devices
  */
  md: column,

  /**
  * The number of columns to span on large devices
  */
  lg: column,

  /**
  * The number of columns to span on extra large devices
  */
  xl: column,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object])
};
GridCol.propTypes = GridColPropTypes;
GridCol.displayName = 'GridCol';

var Grid = {
  Container: GridContainer,
  Row: GridRow,
  Col: GridCol
};

var styles = {"gridPaneContainer":"GridPane-module_gridPaneContainer__1jvYJ","gridPaneChild":"GridPane-module_gridPaneChild__2ZI27","withShadow":"GridPane-module_withShadow__6Qq8d"};

var _excluded$1 = ["children", "gridContainer", "gridRow"];

var GridPaneContainer = function GridPaneContainer(_ref) {
  var children = _ref.children,
      gridContainer = _ref.gridContainer,
      gridRow = _ref.gridRow,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React__default["default"].createElement(Grid.Container, _extends({
    className: cx__default["default"](styles.gridPaneContainer)
  }, gridContainer, props), /*#__PURE__*/React__default["default"].createElement(Grid.Row, gridRow, children));
};

GridPaneContainer.propTypes = {
  children: PropTypes__default["default"].node,
  gridContainer: PropTypes__default["default"].shape(_objectSpread2({}, GridContainerPropTypes)),
  gridRow: PropTypes__default["default"].shape(_objectSpread2({}, GridRowPropTypes))
};

var _excluded = ["children", "gridCol", "withShadow"];

var GridPaneChild = function GridPaneChild(_ref) {
  var children = _ref.children,
      gridCol = _ref.gridCol,
      withShadow = _ref.withShadow,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Grid.Col, _extends({
    className: cx__default["default"](styles.gridPaneChild, withShadow && styles.withShadow)
  }, gridCol, props), children);
};

GridPaneChild.propTypes = {
  children: PropTypes__default["default"].node,
  className: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),
  gridCol: PropTypes__default["default"].shape(_objectSpread2({}, GridColPropTypes)),
  withShadow: PropTypes__default["default"].bool
};
GridPaneChild.defaultProps = {
  withShadow: true
};

var GridPane = {
  Child: GridPaneChild,
  Container: GridPaneContainer
};

var Box = {
  Regular: RegularBox,
  Flexbox: Flexbox,
  FlexboxPane: FlexboxPane,
  ContentPane: FlexboxPane,
  // renamed
  Scrollable: Scrollable,
  Grid: Grid,
  GridPane: GridPane
};

module.exports = Box;
